<div class="instruction-content-wrapper" *ngIf="currentPlatformClientsConfig.length > 0">
    <div class="block-header third-party-header">
        <div class="header-title-wrapper">
            <span class="header-title">{{ 'ThirdPartyClient.title' | translate }}</span>
            <div class="redline"></div>
        </div>
        <div class="client-selector">
            <button *ngFor="let client of currentPlatformClientsConfig" class="client-select-btn"
                [class.selected]="selectedClient.name === client.name" (click)="onIconClick(client.name)">
                {{client.name}}
            </button>
        </div>
        <div class="header-icons">
            <div *ngFor="let client of currentPlatformClientsConfig" class="header-icon-wrapper">
                <span class="header-icon" (click)="onIconClick(client.name)">
                    <img class="header-icon-img" [class.selected]="selectedClient.name === client.name"
                        [src]="client.icon" alt="{{client.name}} icon">
                </span>
            </div>
        </div>
    </div>

    <!-- Clash X App -->
    <div class="client-item">
        <div class="client-header-wrapper">
            <div class="client-header">
                <div class="client-logo">
                    <img class="client-logo-img" [src]="selectedClient.icon" [alt]="selectedClient.name + ' icon'">
                </div>
                <span class="client-title">{{selectedClient.name}}</span>
            </div>
            <a *ngFor="let ip of deliveryIps; let i = index" class="client-guide"
                [href]="generateGuideUrl(ip, selectedClient.guidePath)" target="_blank">
                {{ 'ThirdPartyClient.guide' | translate }} {{i + 1}}
                <app-chevron-right />
            </a>
        </div>
        <div class="mobile-link-area" *ngIf="subscriptionUrl">
            <p>{{ 'ThirdPartyClient.subscriptionAddress' | translate }}：{{ subscriptionUrl }}</p>
        </div>
        <div class="download-actions-mobile">
            <ng-container *ngIf="selectedClient.proxyDownloadLink && appDomains.length > 0">
                <button class="download-btn" (click)="onDownloadClick(selectedClient.name, 0)">
                    {{ 'ThirdPartyClient.download' | translate }} <ui-download />
                </button>
            </ng-container>
            <ng-container *ngIf="!selectedClient.proxyDownloadLink">
                <button class="download-btn" (click)="openThirdPartyClientWebsite(selectedClient.downloadLinks[0])">
                    {{ 'ThirdPartyClient.download' | translate }} <ui-download />
                </button>
            </ng-container>
            <button class="download-btn" (click)="showQrCode(subscribePath, apiDomains[0])">
                {{ 'ThirdPartyClient.qrCode' | translate }} <rubiz-scan-icon />
            </button>
            <button class="download-btn" (click)="onOpenAppClick()">
                {{ 'ThirdPartyClient.openApp' | translate }} <app-rubiz-ui-vector />
            </button>
        </div>
        <div *ngIf="selectedClient.proxyDownloadLink" class="download-actions-pc">
            <button class="download-btn" *ngFor="let domain of appDomains; let i = index"
                (click)="onDownloadClick(selectedClient.name, i)">
                {{ 'ThirdPartyClient.download' | translate }}{{i + 1}}<br />
            </button>
        </div>
        <div *ngIf="!selectedClient.proxyDownloadLink" class="download-actions-pc">
            <button class="download-btn" *ngFor="let link of selectedClient.downloadLinks; let index = index"
                (click)="openThirdPartyClientWebsite(link)">
                {{ 'ThirdPartyClient.download' | translate }}{{index + 1}}<br />
            </button>
        </div>
        <ul class="subscription-address-list-pc">
            <li class="subscription-address" *ngFor="let domain of apiDomains; let index = index">
                <span>{{ getNumberedCircle(index + 1) }} {{ 'ThirdPartyClient.subscriptionAddress' | translate }}</span>
                <div class="subscription-actions">
                    <span class="link" (click)="copyUrl(subscribePath, domain)">{{ 'ThirdPartyClient.copy' | translate
                        }}</span>
                    <div class="vertical-divider"></div>
                    <span class="link" (click)="showQrCode(subscribePath, domain)">{{ 'ThirdPartyClient.qrCode' |
                        translate }} <rubiz-scan-icon /></span>
                    <div class="vertical-divider"></div>
                    <span class="link" (click)="showQrCode(subscribePath, domain)">{{ 'ThirdPartyClient.view' |
                        translate }}</span>
                </div>
            </li>
        </ul>
    </div>
    <app-modal [(visible)]="modalVisible" [confirmText]="'Common.Modal.confirm' | translate"
        [cancelText]="'Common.Modal.cancel' | translate" [confirmDanger]="true" (confirm)="onConfirm()"
        (cancel)="onCancel()">
        <div class="modal-content">
            <img [src]="qrCodeUrl" alt="QR Code" />
            <div>{{ 'ThirdPartyClient.scanQRCode' | translate:{appName: selectedClient.name} }}</div>
            <div>{{ 'ThirdPartyClient.orCopyLink' | translate }}</div>
            <div class="subscription-url">{{ subscriptionUrl }}</div>
        </div>
    </app-modal>
</div>